import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Input, Button, message, Image, Select } from "antd";
import { imgSrc } from "../../../modules";
import { post } from "../../../modules/axios";
import "./contact.css";

const contactReCapcha = React.createRef();
const recaptcha_key = process.env.REACT_APP_RECAPCHA;

class ContactComponent extends React.Component {
    state = {
        recapcha: false,
        loading: false,
    };
    onChange = (value) => {
        this.setState({ recapcha: value });
    };
    onFinish = (value) => {
        const { recapcha } = this.state;
        if (!recapcha) message.warning("Invalid ReCapcha!");
        this.setState({ loading: true });
        post("contact.php", { ...value, recapcha }, (res) => {
            alert(res);
            contactReCapcha.current.reset();
            this.setState({ loading: false });
        });
    };

    // onFinish = (values) => {
    //     console.log('Success:', values);
    // };
    
    // onFinishFailed = (errorInfo) => {
    //     console.log('Failed:', errorInfo);
    // };

    render() {
        const { loading } = this.state;
        return (
            <div id="contact">
                {/* <div id="ptt">
                    <button type="button" onclick="$(this).parent().hide()">
                        <i class="fa fa-times"></i>
                    </button>
                    <iframe src="http://www.pttplc.com/th/pages/oilprice.aspx" title="ptt" width="200" height="380" frameBorder="0" allowTransparency="true" allow="encrypted-media"></iframe>
                </div> */}
                <div className="container">
                    <h2>ติดต่อเรา</h2>
                    <h1>บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด</h1>
                    <iframe title="ที่ตั้ง บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d969.486670358688!2d100.77538393872177!3d13.600068725659348!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDM2JzAwLjMiTiAxMDDCsDQ2JzMyLjkiRQ!5e0!3m2!1sen!2sth!4v1613799137243!5m2!1sen!2sth" width="100%" height="400" frameBorder="0" allowFullScreen></iframe>
                    <div id="responsive-address">
                        <b className="orange">ที่อยู่</b>
                        <br /> 109/3 ซอย ปลูกจิตต์ ถ.พระราม 4 แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330
                        <br />
                        <br />
                        <p>
                            <b className="orange">โทรศัพท์:</b>
                            <br />
                            <a href="tel:023372529">0-2337-2529</a>
                        </p>
                        <p>
                            <b className="orange">แฟกซ์</b>
                            <br />
                            0-2655-8717, 0-2337-2524
                        </p>
                        <p>
                            <b className="orange">เว็บไซต์</b>
                            <br />

                            <a href="http://cpntransport.com">www.cpntransport.com</a>
                        </p>
                        <p>
                            <b className="orange">อีเมล</b>
                            <br />
                            <a href="mailto:cpntransport@hotmail.com">cpntransport@hotmail.com</a>
                        </p>
                    </div>
                    <div id="contact-warp">
                        <div id="contact-content">
                            <div>
                                <div>
                                    <div>
                                        <b className="orange">ติดต่อสมัครงาน:</b>
                                        <br />
                                        1. แผนที่สมัครงาน
                                        <br />
                                        <Image width={"100%"} src={imgSrc("map.jpg")} alt="แผนที่ตั้ง บริษัทซีพีเอ็น ทรานสปอร์ต จำกัด" />
                                        <p className="text-center">(คลิกเพื่อดูรูปใหญ่)</p>
                                    </div>
                                    <div>
                                        2. QR code สมัครงาน
                                        <br />
                                        <Image width={"100%"} className="mb15" src={imgSrc("line-job.png")} alt="QR code - Registration" />
                                    </div>
                                    <div>
                                        3. Facebook สมัครงาน
                                        <br />
                                        <p>
                                            <a href="https://th-th.facebook.com/JobJobTransport" target="_blank" rel="noreferrer">
                                                <u>jobjobtransport</u>
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <b className="orange">ที่อยู่</b>
                                <br /> 109/3 ซอย ปลูกจิตต์ ถ.พระราม 4 แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330
                                <br />
                                <br />
                                <p>
                                    <b className="orange">โทรศัพท์:</b>
                                    <br />
                                    <a href="tel:023372529">0-2337-2529</a>
                                </p>
                                <p>
                                    <b className="orange">แฟกซ์</b>
                                    <br />
                                    0-2655-8717, 0-2337-2524
                                </p>
                                <p>
                                    <b className="orange">เว็บไซต์</b>
                                    <br />

                                    <a href="http://cpntransport.com">www.cpntransport.com</a>
                                </p>
                                <p>
                                    <b className="orange">อีเมล</b>
                                    <br />
                                    <a href="mailto:cpntransport@hotmail.com">cpntransport@hotmail.com</a>
                                </p>
                            </div>
                        </div>
                        <div id="contact-form">
                            <Form onFinish={this.onFinish} className="login-form" initialValues={{ subject: "สนใจบริการของเรา" }}>
                                <Form.Item name="name" rules={[{ required: true, message: "Please input your name" }]}>
                                    <Input placeholder="ชื่อ-สกุล" />
                                </Form.Item>
                                <Form.Item name="phone" rules={[{ required: true, message: "Please input your phone" }]}>
                                    <Input placeholder="เบอร์โทร" />
                                </Form.Item>
                                <Form.Item
                                    name="email"
                                    rules={[
                                        { type: "email", message: "The input is not valid E-mail!" },
                                        { required: true, message: "Please input your E-mail!" },
                                    ]}
                                >
                                    <Input placeholder="อีเมล" />
                                </Form.Item>
                                <Form.Item name="subject" rules={[{ required: true, message: "Please input your subject" }]}>
                                    <Select>
                                        <Select.Option value="สนใจบริการของเรา">สนใจบริการของเรา</Select.Option>
                                        <Select.Option value="สมัครร่วมงานกับเรา">สมัครร่วมงานกับเรา</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item name="message" rules={[{ required: true, message: "Please input your message" }]}>
                                    <Input.TextArea rows={4} placeholder="ข้อความติดต่อ" />
                                </Form.Item>
                                <div id="wrap-submit">
                                    <ReCAPTCHA ref={contactReCapcha} sitekey={recaptcha_key} onChange={this.onChange} />
                                    <Button type="primary" htmlType="submit" >
                                        {loading ? "Sending..." : "Submit"}
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// const WarpContactComponent = Form.create()(ContactComponent)

export default ContactComponent;
